import React from "react"
import styled, { css } from "styled-components"
import { Paragraph, RoundButton, HeadingTwo } from "buoy-core"
import { responsive, colors } from "buoy-theme"
import FormField from "./FormField"

const Heading = styled(HeadingTwo)`
  margin-bottom: 12px;
`

const Subheading = styled(Paragraph)`
  margin-top: 0;
  margin-bottom: 26px;
`

const PlanDetailsCard = styled.div`
  width: 100%;
  display: flex;
  ${responsive(
    "padding",
    "40px",
    "40px",
    "40px",
    "40px",
    "24px 16px"
  )};
  ${responsive("margin-top", "80px", "80px", "24px", "24px", "16px")};
  position: relative;
  flex-direction: column;
  border-radius: 4px;
  background-color: #8018ff;

  button {
    margin-top: 20px;
    max-width: 253px;
  }
`

const Row = styled.div`
  display: flex;
  ${responsive("flex-direction", "row", "row", "column", "column", "column")};
  > div {
    ${responsive("margin", "8px", "8px", "8px 0", "8px 0", "8px 0")};
    margin: 8px;
  }
  > div:first-child {
    margin-left: 0px;
  }
  > div:last-child {
    margin-right: 0px;
  }
  ${props =>
    props.disabled
      ? css`
          cursor: not-allowed;
          div {
            pointer-events: none;
            background-color: ${colors.neutralLight};
            border-color: ${colors.neutralLight};
            transition: all ease 0.5s;
          }
        `
      : ""};
`

FormField.defaultProps = {
  isEditing: true,
  RowContainer: Row,
}

const DashboardForm = ({
  config,
  office,
  planProvider,
  plan,
  holder,
  onOfficeResponse,
  onPlanProviderResponse,
  onPlanResponse,
  onHolderResponse,
  submitPlanInformation,
  disabled,
}) => (
  <PlanDetailsCard>
    <Heading color="white" alignLeft>
      {config.heading}
    </Heading>
    <Subheading color="white">{config.body}</Subheading>
    <Row disabled={office.options.length === 0}>
      <FormField
        disabled={office.options.length === 0}
        placeholder={config.fields.office.placeholder}
        options={office.options}
        value={office.selected}
        onChange={onOfficeResponse}
      />
    </Row>
    <Row disabled={planProvider.options.length === 0}>
      <FormField
        disabled={planProvider.options.length === 0}
        value={planProvider.selected}
        onChange={onPlanProviderResponse}
        options={planProvider.options}
        placeholder={config.fields.planProvider.placeholder}
      />
    </Row>
    {/* <Row disabled={plan.options.length === 0}>
      <FormField
        disabled={plan.options.length === 0}
        value={plan.selected}
        onChange={onPlanResponse}
        options={plan.options}
        placeholder={config.fields.plan.placeholder}
      />
    </Row> */}
    {holder !== "NA" && (
      <Row disabled={!plan.selected}>
        <FormField
          disabled={!plan.selected}
          value={holder}
          onChange={onHolderResponse}
          options={config.fields.holder.options}
          placeholder={config.fields.holder.placeholder}
        />
      </Row> 
    )}
    <RoundButton
        disabled={disabled}
        color="neutralLightest"
        textColor="primary"
        onClick={submitPlanInformation}
      >
        {config.button.text}
      </RoundButton>
  </PlanDetailsCard>
)

export { DashboardForm as default }


// WEBPACK FOOTER //
// ./assets/common/components/PlanDetails/components/DashboardForm.js